export const getRubriques = state => state.contact.data
export const isRubriquesLoading = state => state.contact.loading
export const getExpirationDate = state => state.contact.expirationDate
export const isRechercheLoading = state => state.contact.loadingRecherche
export const getRecherche = state => state.contact.recherche
